module.exports = __webpack_public_path__ + "bf2a8d9de9aecafa0867f707e128d583.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/tech-in-asia.png
// module id = 658
// module chunks = 47